function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import merge from "lodash/merge";
import * as ActionTypes from "../../actions";

// Updates an entity cache in response to any action with response.entities.
var goalEntities = function goalEntities() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    byId: {}
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ActionTypes.GET_GOALVIEWBYGOALIDANDAUTHUSERID_SUCCESS:
      var byId = action.response.goalById;
      return merge({}, state, {
        byId: byId
      });
    case ActionTypes.GET_EVENTLISTITEMSBYUSERIDANDEVENTTYPEIDIN_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      action.response.forEach(function (eventListItem) {
        return merge(byId, eventListItem.goalById);
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_GOALBYID_SUCCESS:
      if (!action.response) return state;
      var byId = _objectSpread({}, state.byId);
      byId[action.id] = action.response;
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.GET_GOALS_SUCCESS:
      if (!action.response._embedded) return state;
      var byId = _objectSpread({}, state.byId);
      action.response._embedded.goals.forEach(function (goal) {
        byId[goal.id] = goal;
      });
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALDUEDATE_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.dueDate = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOAL_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      if (action.goalId) merge(byId[action.goalId], action.response._embedded);else byId[action.response._embedded.id] = action.response._embedded;
      return merge({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALPICTURE_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.picture = action.response._embedded;
        goal.displayablePicture = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALBACKGROUNDPICTURE_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.backgroundPicture = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALAMOUNTS_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.amounts = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALMEMBERS_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.members = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    case ActionTypes.POST_GOALEXCLUSIONPREFERENCES_SUCCESS:
      var byId = _objectSpread({}, state.byId);
      var goal = byId[action.goal.id];
      if (goal) {
        var goal = _objectSpread({}, goal);
        goal.exclusionPreferences = action.response._embedded;
        byId[action.goal.id] = goal;
      }
      return Object.assign({}, state, {
        byId: byId
      });
    default:
      return state;
  }
};
export default goalEntities;